<template>
  <div class="contacts container">
    <v-container>
      <h1>CONTACTS</h1>

      <v-container>
        <contact-table :contacts="UserListJson"></contact-table>
      </v-container>
    </v-container>
  </div>
</template>

<script>
import contactTable from "../../components/Contact/contactTable.vue";
import UserListJson from "../../components/UserProfiles/UserList.json";
/* eslint-disable */
export default {
  components: { contactTable },
  name: "contacts",
  route: {
    name: "Contacts",
    path: "/contacts*",
  },
  data() {
    return {
      UserListJson,
    };
  },
};
</script>

<style></style>
